
export class ActionUpdateRequest {
    action: string;
    data: any;
}